import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { image_url } from "../../api/bootapi";
import { IconModalBody } from "../DeviceSettingGPS/DeviceSettingGPSRight";
import { useStateValue } from "../../Registration/Components/ContextAPI/StateProvider";

const DeviceSettingOBDRight = () => {
  const [{ devicesetting, vehicleimages, vehicle_colors_obj2 }, dispatch] =
    useStateValue();
  const [colormodal, setcolormodal] = useState(false);
  const handlecolormodal = () => setcolormodal(!colormodal);

  const callreducer = (val) => {
    dispatch({
      type: "ADD_TO_DEVICESETTINGS",
      devicesetting: val,
    });
  };
  const inputEvent = (e) => {
    let name = e.target.name;
    devicesetting[`${name}`] = e.target.checked;
    callreducer(devicesetting);
  };
  const getimagename = (value, i) => {
    return `${image_url}/${value}_${vehicle_colors_obj2[i]["text"]}.png`;
  };
  const handleselectedimage = (type, color) => {
    handlecolormodal();
    devicesetting.vehicle_type = type;
    if (
      type === "car" ||
      type === "bus" ||
      type === "marker" ||
      type === "minibus" ||
      type === "minitruck" ||
      type === "truck"
    ) {
      devicesetting.vehicle_color = vehicle_colors_obj2[color]["text"];
    } else {
      devicesetting.vehicle_color = color;
    }
    callreducer(devicesetting);
  };
  return (
    <div style={{ marginLeft: "20px" }}>
      <div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Current Device Frequency:</strong>
          </div>
          <div className="col-md-8">
            <p className="devicesetingright_headerp">
              {devicesetting.device_reporting_frequency_desc}
            </p>
          </div>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <h5 className="text-center">Device Information to show</h5>
        <hr />
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Vehicle Speed:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_speed"
                checked={devicesetting.show_speed}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Engine RPM:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_engine_rpm"
                checked={devicesetting.show_engine_rpm}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Vehicle Mileage:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_mileage"
                checked={devicesetting.show_mileage}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Engine Temperature:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_engine_temp"
                checked={devicesetting.show_engine_temp}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Power Voltage:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_voltage"
                checked={devicesetting.show_voltage}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Engine Load:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_engine_load"
                checked={devicesetting.show_engine_load}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Throttle Position:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_throttle_position"
                checked={devicesetting.show_throttle_position}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Fuel Level:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_fuel_level"
                checked={devicesetting.show_fuel_level}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Vehicle Location:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_location"
                checked={devicesetting.show_location}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
      </div>
      <div>
        <h5 className="text-center">Tracker Skins</h5>
        <hr />
        <div>
          <div className="row marginrow">
            <div className="col-md-4 textalignleft">
              <strong>Tracker</strong>
            </div>
            <div className="col-md-8 devicesettingleft">
              <img
                alt="currentvehicle"
                style={{ maxHeight: "40px" }}
                src={`${image_url}/${devicesetting.vehicle_type}_${devicesetting.vehicle_color}.png`}
              />
              <button
                className="btn btn-primary ml-2"
                onClick={handlecolormodal}
              >
                Choose Icon
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={colormodal}
        onHide={() => handlecolormodal()}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Pick Tracker Icon!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <IconModalBody
            getimagename={getimagename}
            vehicleimages={vehicleimages}
            handleselectedimage={handleselectedimage}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DeviceSettingOBDRight;
